import {Hero} from '@primer/react-brand'

import type {PrimerComponentHero} from '../../../schemas/contentful/contentTypes/primerComponentHero'
import {TrailingComponent} from './components/TrailingComponent/TrailingComponent'
import {getAnalytics} from '../../../lib/utils/analytics'

export type ContentfulHeroProps = {
  component: PrimerComponentHero

  'data-hpc'?: boolean
}

export function ContentfulHero({component, ...props}: ContentfulHeroProps) {
  const hasTrailingComponent =
    component.fields.trailingComponent !== undefined && component.fields.trailingComponent.length > 0

  return (
    <Hero
      data-hpc={props['data-hpc']}
      align={component.fields.align}
      trailingComponent={
        hasTrailingComponent ? () => <TrailingComponent components={component.fields.trailingComponent} /> : undefined
      }
    >
      {component.fields.label && <Hero.Label>{component.fields.label}</Hero.Label>}

      <Hero.Heading>{component.fields.heading}</Hero.Heading>

      {component.fields.description ? <Hero.Description>{component.fields.description}</Hero.Description> : null}

      {!hasTrailingComponent && component.fields.callToActionPrimary !== undefined && (
        <Hero.PrimaryAction
          href={component.fields.callToActionPrimary.fields.href}
          {...getAnalytics({
            action: component.fields.callToActionPrimary.fields.text,
            labels: [{key: 'label', value: 'hero'}],
            fullstoryDataRef: `hero-primary-action-${component.fields.callToActionPrimary.sys.id}`,
          })}
        >
          {component.fields.callToActionPrimary.fields.text}
        </Hero.PrimaryAction>
      )}

      {!hasTrailingComponent && component.fields.callToActionSecondary !== undefined && (
        <Hero.SecondaryAction
          href={component.fields.callToActionSecondary.fields.href}
          {...getAnalytics({
            action: component.fields.callToActionSecondary.fields.text,
            labels: [{key: 'label', value: 'hero'}],
            fullstoryDataRef: `hero-secondary-action-${component.fields.callToActionSecondary.sys.id}`,
          })}
        >
          {component.fields.callToActionSecondary.fields.text}
        </Hero.SecondaryAction>
      )}

      {component.fields.image !== undefined && (
        <Hero.Image
          position={component.fields.imagePosition === 'Inline' ? 'inline-end' : 'block-end'}
          src={component.fields.image.fields.file.url}
          alt={component.fields.image.fields.description || ''}
        />
      )}
    </Hero>
  )
}

try{ ContentfulHero.displayName ||= 'ContentfulHero' } catch {}